module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAM9JREFUSInFlFEOgyAMhr9yB6O3GTvZwsnsbrOEQ7CHGaMbWpCQ/U8ktv9XSq3ECU9iBhQhDC+UBsUJD3gSN4QgcWQG/Boh3K9CNsWucgjPXVRiXqpoNgfUQabaSsiBOQhBjACzXVaulAZeMf8cKxNqY+X7e0liTSE/AMsAoKaVWcApJKeTdzoEFEOMSTsFmJCCMXYWoFX/a1HXR+46pl1/tK6rouuy67quW8xLII7Eo8UcYHih64Tt5SWOpBbzrTI3UbeQFSG0mMPuJroUG97bT7KuEOpLFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(55).png
// module id = BlHs
// module chunks = 1